"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const material_1 = require("@mui/material");
const icons_material_1 = require("@mui/icons-material");
const cardThemes = {
    card: {
        cursor: 'pointer',
        boxShadow: 'none',
        border: '2px solid #DDE0E0',
        borderRadius: '1.5rem',
    },
    card_chip_grey: {
        backgroundColor: '#999999',
        color: 'white',
        cursor: 'pointer',
        width: 'max-content',
        fontFamily: 'Effra',
        borderRadius: '0.375rem',
        fontSize: '0.75rem',
    },
};
const QuizCard = (props) => {
    return (react_1.default.createElement(material_1.Card, { sx: { ...cardThemes.card, maxWidth: '18rem' } },
        react_1.default.createElement("div", null,
            react_1.default.createElement(material_1.IconButton, { sx: { position: 'absolute', margin: '0.25rem 0rem 0rem 0.25rem' } },
                react_1.default.createElement(icons_material_1.Favorite, { sx: { color: props.isFavorite ? 'red' : '', opacity: '50%' } })),
            react_1.default.createElement(material_1.CardMedia, { component: 'img', sx: { objectFit: 'cover', height: '10rem' }, image: props.imageSrc })),
        react_1.default.createElement(material_1.CardContent, { sx: {
                display: 'flex',
                flexDirection: 'column',
                gap: '0.5rem',
            } },
            react_1.default.createElement("div", { style: {
                    display: 'flex',
                    flexDirection: 'row',
                    alignItems: 'center',
                    justifyContent: 'space-between',
                    // paddingRight: "1rem",
                } },
                react_1.default.createElement(material_1.Typography, { sx: {
                        fontWeight: '700',
                        fontSize: '1.275rem',
                        fontFamily: 'Bryant Pro',
                        whiteSpace: 'nowrap',
                        overflow: 'clip',
                        textOverflow: 'ellipsis',
                        maxWidth: '13rem',
                    } }, props.title),
                react_1.default.createElement(material_1.IconButton, { onClick: props.menuOnClick },
                    react_1.default.createElement(icons_material_1.MoreHoriz, null))),
            react_1.default.createElement("div", { style: { fontFamily: 'Effra', color: '#757777' } }, props.description),
            react_1.default.createElement("div", { style: { padding: '0.5rem 0rem' } },
                react_1.default.createElement(material_1.Divider, null)),
            react_1.default.createElement("div", { style: { display: 'flex', flexDirection: 'row', gap: '0.5rem' } },
                react_1.default.createElement(material_1.Chip, { sx: cardThemes.card_chip_grey, label: props.subject }),
                react_1.default.createElement(material_1.Chip, { sx: cardThemes.card_chip_grey, label: `${props.questions} QUESTIONS` })))));
};
exports.default = QuizCard;
